/* Toont de juiste kleurenlijst bij de gekozen variant. Vervangt de
   conditional logic van Globo, en werkt ook als het theme de sectie niet
   opnieuw rendert bij een variantwissel.

   Terugval voor producten zonder echte varianten. 310 servetten hebben nog
   alleen Title / Default Title. Hun combo leest dan als '~': geen maat, geen
   foil, waardoor elke groep met data-when-size of data-when-foil verborgen
   blijft en de klant helemaal geen kleuren te zien krijgt.

   Die ene variant is de instapprijs van beverage zonder foil, dus dat is ook
   wat we tonen. Zodra het product echte varianten krijgt, komt de combo uit de
   map en doet de terugval niets meer.

   data-when-placement werkt net zo, maar luistert naar het radioveld Print
   placement in plaats van naar de variant. Er zijn twee aparte Border
   finish-groepen: een bij Square en een bij Diamond, elk met eigen staaltjes.
   De rand ziet er bij een diagonale plaatsing anders uit, dus de vierkante
   staaltjes kloppen daar niet.

   Groepen worden in documentvolgorde afgehandeld, dus een geneste groep kan
   controleren of een bovenliggende groep al verborgen is. Zonder die controle
   zou een Border finish-veld weer zichtbaar worden bij guest towel, waar het
   hele blok Print placement juist niet hoort te staan.

   VERBORGEN VELDEN MOGEN NOOIT MEE NAAR DE CART (bug 2026-10-09). Elke
   kleurgroep heeft White als standaard. Een verborgen groep die niet disabled
   is, stuurt die White dus gewoon mee, en dan staat er op de checkout zes keer
   Napkin color onder elkaar. Horizon rendert de sectie opnieuw bij een
   variantwissel en zet daarbij de inputs terug zonder disabled, soms nadat
   apply() al gedraaid heeft. Daarom draait apply() ook synchroon vlak voor het
   versturen (submit en klik op de knoppen, in de capture-fase, dus voor
   Horizon de FormData leest) en nog een keer kort na een variantwissel.
   product-addons.js roept window.ypdNapkinApply ook zelf aan voor het de
   FormData leest.

   NAAMGEVING (2026-10-09, besluit Iris: Globo staat uit, keys zijn opgeschoond
   naar nette namen). Groepen die om de beurt zichtbaar zijn sturen dezelfde
   property, bv. zes keer 'Napkin color'. Een gedeelde name zou van al die
   radio's een radiogroep maken. Daarom rendert snippets/napkin-option-field
   ze met een eigen name opt-<uid> en de echte sleutel in data-cart-key. Na het
   tonen en verbergen volgen twee stappen, zodat namen nooit botsen:
     1. inputs in een verborgen groep krijgen opt-off-<groep> en disabled;
     2. inputs in een zichtbare groep krijgen properties[<cart-key>].
   De checked-stand wordt bewaard en zo nodig teruggezet. */
(function () {
  'use strict';

  var FALLBACK_SIZE = 'cocktail';
  var FALLBACK_FOIL = 'no';
  var FALLBACK_PLACEMENT = 'Square';
  var CART_FORM = 'form[action*="/cart/add"]';

  function cartForm() {
    return document.querySelector(CART_FORM);
  }

  function sizeKey(value) {
    var text = (value || '').toLowerCase();
    if (text.indexOf('cocktail') !== -1) return 'cocktail';
    if (text.indexOf('dinner') !== -1) return 'dinner';
    if (text.indexOf('guest') !== -1) return 'guest';
    return '';
  }

  function foilKey(value) {
    var text = (value || '').toLowerCase();
    if (text.indexOf('yes') === 0) return 'yes';
    if (text.indexOf('no') === 0) return 'no';
    /* Nieuwe waardenamen (test 2026-10-09): 'Metallic foil' en 'No foil' */
    if (text.indexOf('metallic') !== -1) return 'yes';
    return '';
  }

  function placementKey(root) {
    var checked = root.querySelector('input[data-cart-key="Print placement"]:checked') ||
      root.querySelector('input[name="properties[Print placement]"]:checked');
    return (checked && checked.value) || FALLBACK_PLACEMENT;
  }

  function hiddenAncestor(group) {
    var parent = group.parentElement;
    return parent ? parent.closest('.napkin-options__group[hidden]') : null;
  }

  /* De oorspronkelijke groepsnaam (opt-<uid>) wordt een keer onthouden, zodat
     een verborgen groep altijd een eigen, unieke naam terugkrijgt. */
  function baseName(input, index) {
    if (!input.dataset.optName) {
      var name = input.name || '';
      if (name.indexOf('opt-') !== 0 || name.indexOf('opt-off-') === 0) name = 'opt-x' + index;
      input.dataset.optName = name;
    }
    return input.dataset.optName;
  }

  function rename(input, name) {
    if (input.name === name) return;
    var wasChecked = input.checked;
    input.name = name;
    if (wasChecked && !input.checked) input.checked = true;
  }

  function nameCartKeys(root) {
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-cart-key]'));
    var visible = [];

    /* Stap 1: alles in een verborgen groep uit de cart-namen halen. */
    inputs.forEach(function (input, index) {
      var base = baseName(input, index);
      if (input.closest('.napkin-options__group[hidden]')) {
        rename(input, 'opt-off-' + base.slice(4));
        input.disabled = true;
      } else {
        visible.push(input);
      }
    });

    /* Stap 2: pas daarna de zichtbare groepen de echte property geven. */
    visible.forEach(function (input) {
      rename(input, 'properties[' + input.getAttribute('data-cart-key') + ']');
      input.disabled = false;
    });
  }

  function apply() {
    var root = document.querySelector('[data-napkin-options]');
    if (!root) return;

    var mapNode = root.querySelector('[data-variant-map]');
    var map = {};
    if (mapNode) {
      try { map = JSON.parse(mapNode.textContent); } catch (e) { map = {}; }
    }

    var form = cartForm();
    var field = form ? form.querySelector('[name="id"]') : null;
    var combo = (field && map[field.value]) || '';

    var parts = combo.split('~');
    var size = sizeKey(parts[0]) || FALLBACK_SIZE;
    var foil = foilKey(parts[1]) || FALLBACK_FOIL;
    var placement = placementKey(root);

    root.querySelectorAll('[data-when-size], [data-when-foil], [data-when-placement]').forEach(function (group) {
      var wantSize = group.getAttribute('data-when-size');
      var wantFoil = group.getAttribute('data-when-foil');
      var wantPlacement = group.getAttribute('data-when-placement');
      var show = true;

      if (wantSize && wantSize.split(' ').indexOf(size) === -1) show = false;
      if (wantFoil && wantFoil !== foil) show = false;
      if (wantPlacement && wantPlacement !== placement) show = false;
      if (show && hiddenAncestor(group)) show = false;

      group.hidden = !show;
      group.querySelectorAll('input, select, textarea').forEach(function (input) {
        if (input.hasAttribute('data-cart-key')) return;
        input.disabled = !show;
      });
    });

    nameCartKeys(root);
  }

  window.ypdNapkinApply = apply;

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      apply();
    });
  }

  function scheduleLate() {
    schedule();
    setTimeout(apply, 250);
    setTimeout(apply, 800);
  }

  document.addEventListener('change', schedule);
  document.addEventListener('input', schedule);
  ['variant:update', 'variantChange', 'on:variant:change', 'shopify:section:load'].forEach(function (name) {
    document.addEventListener(name, scheduleLate);
  });

  document.addEventListener('submit', function (event) {
    var target = event.target;
    if (target && target.matches && target.matches(CART_FORM)) apply();
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest(CART_FORM + ' button, ' + CART_FORM + ' [type="submit"], .shopify-payment-button, sticky-add-to-cart')) apply();
  }, true);

  function start() {
    apply();
    var form = cartForm();
    if (form) {
      new MutationObserver(schedule).observe(form, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value', 'checked', 'aria-checked', 'selected']
      });
    }
    var root = document.querySelector('[data-napkin-options]');
    if (root && root.parentElement) {
      new MutationObserver(schedule).observe(root.parentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
